import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridData) {
    const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Recruiters?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `Recruiters/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllList() {
  return getRequest(
    `Recruiters/list`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
    return deleteRequest(
    `Recruiters/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return postRequest(
    `Auth/UserRegistration`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data) {
    return putRequest(
    `Recruiters`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllAssignedProjects(gridData, id) {
    const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Recruiters/assigned/projects/${id}?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function report(data) {
    return postRequest(
    `Recruiters/download/recruiter/report`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const recruiterService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
  getAllList,
  getAllAssignedProjects,
  report
};
